import React, { useEffect, useState } from "react";
import { getAllVerifiedBotsForAPIReportsThunk, getAllVerifiedBotsToRunCampaignThunk } from "../../../redux/botManagement/botManagementThunk";
import { useDispatch, useSelector } from "react-redux";
import { useDebouncedValue } from "../../../hooks/useDebouncedValue";

import {
    Card,
    CardContent,
    Chip,
    CircularProgress,
    FormControl,
    Grid,
    IconButton,
    MenuItem,
    Paper,
    styled,
    Table,
    TableBody,
    TableCell,
    tableCellClasses,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    InputLabel,
    Select,
    TextField,
} from "@mui/material";
import SmartToyOutlinedIcon from "@mui/icons-material/SmartToyOutlined";
import { BotStatus, config, ERoles } from "../../../config";
import useAuth from "../../../hooks/useAuth";
import SubjectIcon from "@mui/icons-material/Subject";
import { MessageStatusForCount } from "./ViewBotApiReport";
import { apiGatewayAxiosInstance } from "../../../utils/axios";
import moment from "moment";
import { setApiBotSentLoading, setApiReportData } from "../../../redux/botManagement/botManagementSlice";
import RCSAPIReports from "./RCSAPIReports";
import SMSAPIReports from "./SMSAPIReports";
import TablePaginationShowPage from "../../../utils/tablePagination";
import ChevronLeftRoundedIcon from "@mui/icons-material/ChevronLeftRounded";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import FirstPageRoundedIcon from "@mui/icons-material/FirstPageRounded";
import LastPageRoundedIcon from "@mui/icons-material/LastPageRounded";
import FetchingSpinner from "../../components/FetchingSpinner";
import NoRecords from "../../components/NoRecords";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        fontSize: 20,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 17,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
        border: 0,
    },
}));

export default function BotListApiReport({
    setShowBotReport,
    setSelectedBot,
    selectedBot,
    currentPage,
    pageSize,
    setCurrentPage,
    setPageSize,
    botType,
    setBotType,
}) {
    // botNameSearchTerm
    const [searchQuery, setSearchQuery] = useState("");
    const [debouncedSearchQuery] = useDebouncedValue(searchQuery, 400, { leading: false });

    const dispatch = useDispatch();
    const state = useSelector(state => state.botManagementSlice);
    const { user } = useAuth();

    const handleChangePage = (event, newPage) => {
        setCurrentPage(newPage);
    };
    const handleChangeRowsPerPage = event => {
        setPageSize(parseInt(event.target.value));
        setCurrentPage(0);
    };

    const onClickViewReport = bot => {
        setSelectedBot(bot);
        setShowBotReport(true);
    };

    const getApiReportForBot = async rbmClientId => {
        dispatch(setApiBotSentLoading({ [rbmClientId]: true }));

        try {
            const response = await apiGatewayAxiosInstance.get(`/conversation_logger/api-logger/get-api-reports-by-status-of-bot`, {
                params: {
                    messageStatus: MessageStatusForCount.TotalCount,
                    startDate: moment(new Date()).format("YYYY-MM-DD"),
                    endDate: moment(new Date()).format("YYYY-MM-DD"),
                    botId: rbmClientId,
                },
            });

            dispatch(setApiReportData({ [rbmClientId]: response.data.apiBotReportDetails[MessageStatusForCount.TotalCount] }));
        } catch (error) {
            console.log(error);

            dispatch(setApiReportData({ [rbmClientId]: "-" }));
        }
        dispatch(setApiBotSentLoading({ [rbmClientId]: false }));
    };

    useEffect(() => {
        // dispatch(getAllVerifiedBotsThunk());
        // dispatch(getAllVerifiedBotsToRunCampaignThunk());
        dispatch(getAllVerifiedBotsForAPIReportsThunk({ currentPage, pageSize, botNameSearchTerm: debouncedSearchQuery, botMessageType: botType, showApiBots: true }));
    }, [pageSize, currentPage, botType, debouncedSearchQuery]);

    useEffect(() => {
        // dispatch(getAllVerifiedBotsThunk());
        for (let index = 0; index < state.verifiedBotListForAPIReports.length; index++) {
            const bot = state.verifiedBotListForAPIReports[index];
            if (bot?.config?.rbmClientId) {
                getApiReportForBot(bot.config.rbmClientId);
            }
        }
    }, [state.verifiedBotListForAPIReports]);

    return (
        <Grid>
            <Grid container mb={4} className="listHeader">
                <Grid item md={6} className="align-items-center" marginBottom={"18px"}>
                    <Typography variant="h3">
                        <b>API Report</b>
                    </Typography>
                </Grid>

                <Grid container sx={{ display: "flex", gap: 2, margin: "10px", alignItems: "center", marginLeft: 0 }}>
                    {/* search box for bot name */}
                    {/* <Grid item sx={{ minWidth: 250 }}>
                        <TextField
                            value={searchQuery}
                            name="botName"
                            onChange={e => setSearchQuery(e.target.value)}
                            label="Bot Name"
                            placeholder="Enter Bot Name"
                            size="medium"
                            fullWidth
                        />
                    </Grid> */}
                    {/* dropdown for bot type (promotional/transactional, by default show all) */}
                    <FormControl sx={{ minWidth: 250 }} size="medium">
                        <InputLabel id="bot-type-label">Select Bot Type</InputLabel>
                        <Select
                            labelId="bot-type-label"
                            id="bot-type-select"
                            value={botType}
                            label="Select Bot Type"
                            onChange={e => {
                                const selectedType = e.target.value;
                                console.log("Selected Bot Type:", selectedType);
                                setBotType(selectedType);
                            }}
                            size="medium"
                        >
                            <MenuItem value={"all"}>All</MenuItem>
                            <MenuItem value={"promotional"}>Promotional</MenuItem>
                            <MenuItem value={"transactional"}>Transactional</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>

                {/* <Grid item md={6} className="listHeaderFilter">
                    <Grid display={"flex"} flexDirection={"row"} gap={2}>
                        <IconButton
                            title='Refresh'
                            onClick={reloadList}
                            sx={{
                                animation: state.controls.isGetAllCampaignsLoading ? "spin 0.5s linear infinite" : "",
                                "@keyframes spin": {
                                    "0%": {
                                        transform: "rotate(360deg)",
                                    },
                                    "100%": {
                                        transform: "rotate(0deg)",
                                    },
                                },
                                // marginInline: "20px",
                            }}
                        >
                            <CachedIcon />
                        </IconButton>
                        <Button variant='contained' onClick={handleClickOpenFilterModel}>
                            Filter
                        </Button>
                        {user && user.roleName.toLowerCase() !== ERoles.SUPER_ADMIN && (
                            <>
                                <Button
                                    variant='contained'
                                    onClick={onClickAddNewCampaign}
                                // disabled={
                                //     state.totalCampaignsCount &&
                                //     state.totalCampaignsCount >=
                                //     50
                                // }
                                >
                                    Add New Campaign
                                </Button>
                            </>
                        )}
                    </Grid>
                </Grid> */}
            </Grid>

            <Card className="border border-secondary-50">
                <CardContent sx={{ padding: 0 }}>
                    {state.controls.verifiedBotListForAPIReportsLoading ? (
                        <FetchingSpinner />
                    ) : state.verifiedBotListForAPIReportsCount === 0 ? (
                        <NoRecords />
                    ) : (
                        <>
                            <TableContainer component={Paper} className="table-container" sx={{ maxHeight: "70vh" }}>
                                <Table stickyHeader aria-label="simple table">
                                    <TableHead className="p-3 mb-2 row">
                                        <TableRow>
                                            <StyledTableCell className="tableHeaderFont" align="center">
                                                Sr No
                                            </StyledTableCell>
                                            <StyledTableCell className="tableHeaderFont" align="left">
                                                Bot
                                            </StyledTableCell>
                                            {user?.roleName.toLowerCase() === ERoles.SUPER_ADMIN && (
                                                <StyledTableCell className="tableHeaderFont" align="left">
                                                    Client Name
                                                </StyledTableCell>
                                            )}

                                            <StyledTableCell className="tableHeaderFont" align="left">
                                                Brand
                                            </StyledTableCell>

                                            <StyledTableCell className="tableHeaderFont" align="center">
                                                Bot Message Type
                                            </StyledTableCell>

                                            {/* <StyledTableCell className='tableHeaderFont' align='center'>
          Today RCS Submitted
        </StyledTableCell> */}

                                            <StyledTableCell className="tableHeaderFont" align="center">
                                                View Report
                                            </StyledTableCell>
                                            {(user?.roleName === "reseller_admin" || config.REACT_APP_TO_SHOW_REPORTS_TO_ORG === "true") && (
                                                <StyledTableCell className="tableHeaderFont" align="left">
                                                    RCS Overview
                                                </StyledTableCell>
                                            )}

                                            {(user?.roleName === "reseller_admin" || config.REACT_APP_TO_SHOW_REPORTS_TO_ORG === "true") &&
                                                config.REACT_APP_IS_SMS_CAMPAIGN_REPORT === "true" && (
                                                    <StyledTableCell className="tableHeaderFont" align="left">
                                                        SMS Overview
                                                    </StyledTableCell>
                                                )}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {state?.verifiedBotListForAPIReports?.map((bot, index) => (
                                            <StyledTableRow key={index}>
                                                <StyledTableCell className="tableContentFont" align="center">
                                                    <b>{currentPage * pageSize + index + 1}</b>
                                                </StyledTableCell>
                                                <StyledTableCell className="listBotTableContentFont" align="left">
                                                    <Grid container sx={{ display: "flex", alignItems: "center" }}>
                                                        <Grid item md={3}>
                                                            {bot.botLogoImage.url ? (
                                                                <img src={bot.botLogoImage.url} height={"40px"} width={"40px"} display={"block"} />
                                                            ) : (
                                                                <SmartToyOutlinedIcon />
                                                            )}
                                                        </Grid>
                                                        <Grid item md={9}>
                                                            {bot.botName}
                                                        </Grid>
                                                    </Grid>
                                                </StyledTableCell>

                                                {user?.roleName.toLowerCase() === ERoles.SUPER_ADMIN && (
                                                    <StyledTableCell className="tableContentFont" align="left">
                                                        {bot.clientName}
                                                    </StyledTableCell>
                                                )}

                                                <StyledTableCell className="listBotTableContentFont" align="left">
                                                    {bot.brandName}
                                                </StyledTableCell>

                                                <StyledTableCell className="listBotTableContentFont" align="center">
                                                    {bot.botMessageType}
                                                </StyledTableCell>

                                                {/* <StyledTableCell className='listBotTableContentFont' align='center'>
            {state.apiBotSentLoading[bot.config.rbmClientId] ? <CircularProgress sx={{ marginLeft: '.3rem' }} size={15} /> : state.apiReportSent[bot.config.rbmClientId]}
          </StyledTableCell> */}
                                                <StyledTableCell className="listBotTableContentFont" align="center">
                                                    <IconButton onClick={() => onClickViewReport(bot)}>
                                                        <SubjectIcon />
                                                    </IconButton>
                                                </StyledTableCell>
                                                {(user?.roleName === "reseller_admin" || config.REACT_APP_TO_SHOW_REPORTS_TO_ORG === "true") && (
                                                    <StyledTableCell key={bot._id}>
                                                        {bot?.config?.rbmClientId && <RCSAPIReports bot={bot} />}
                                                    </StyledTableCell>
                                                )}
                                                {(user?.roleName === "reseller_admin" || config.REACT_APP_TO_SHOW_REPORTS_TO_ORG === "true") &&
                                                    config.REACT_APP_IS_SMS_CAMPAIGN_REPORT === "true" && (
                                                        <StyledTableCell>
                                                            <SMSAPIReports bot={bot} />
                                                        </StyledTableCell>
                                                    )}
                                            </StyledTableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                            <Grid
                                className="my-2"
                                style={{
                                    zIndex: "2",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    padding: 2,
                                }}
                            >
                                <Grid
                                    style={{
                                        zIndex: "2",
                                        display: "flex",
                                        justifyContent: "space-between",
                                        width: "100%",
                                        padding: 5,
                                    }}
                                >
                                    <Grid
                                        style={{
                                            marginTop: "15px",
                                        }}
                                    >
                                        Total : {state.verifiedBotListForAPIReportsCount}
                                    </Grid>
                                    <Grid justifyContent={"center"} mt={3}>
                                        <TablePaginationShowPage
                                            rowsPerPageOptions={[5, 10, 25, 100]}
                                            colSpan={3}
                                            count={state.verifiedBotListForAPIReportsCount}
                                            rowsPerPage={pageSize}
                                            page={currentPage}
                                            slotProps={{
                                                select: {
                                                    "aria-label": "Rows per page",
                                                },
                                                actions: {
                                                    showFirstButton: true,
                                                    showLastButton: true,
                                                    slots: {
                                                        firstPageIcon: FirstPageRoundedIcon,
                                                        lastPageIcon: LastPageRoundedIcon,
                                                        nextPageIcon: ChevronRightRoundedIcon,
                                                        backPageIcon: ChevronLeftRoundedIcon,
                                                    },
                                                },
                                            }}
                                            onPageChange={handleChangePage}
                                            onRowsPerPageChange={handleChangeRowsPerPage}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </>
                    )}
                </CardContent>
            </Card>
        </Grid>
    );
}
